import { useMsal } from "@azure/msal-react";
import LoginPage from "../pages/LoginPage";

export default function ProtectedRoute({ children }) {
  const { accounts, inProgress } = useMsal();

  if (inProgress !== "none") {
    return <div>Loading...</div>;
  }

  if (inProgress === "none" && accounts.length === 0) {
    return <LoginPage />;
  }

  return children;
}
